// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__1hR+3"};